<template>
    <app-layout>
        <template #header>
            <div class="relative">
                <div class="absolute top-0 right-0">
                    <inertia-link
                        class="bg-gray-300 hover:bg-gray-500 text-black py-1 px-3 mx-3 rounded my-0"
                        :href="route('extract.index')">
                        <i class="fas fa-arrow-left mx-1"></i> Voltar
                    </inertia-link>

                    <button
                        @click="print()"
                        class="bg-green-500 text-sm hover:bg-green-700 text-white text-base font-bold my-0 -mt-10 py-3 px-6 rounded">
                        <i class="fas fa-download"></i>&nbsp;Download
                    </button>
                </div>
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Comprovante de transação
                </h2>
            </div>
        </template>

        <div class="pb-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 pt-10">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg px-4 py-4">
                    <div>
                        <div class="bg-yellow-50 mt-5 p-5 w-full mx-auto">

                            <div class="grid grid-cols-2">

                                <div class="w-full">
                                    <jet-label for="address_street_number" value="Valor Transacao"/>
                                    <jet-input id="valxor" type="text" class="mt-1 block w-full"
                                               v-model="receipt.content.vlrTransacao"/>
                                </div>

                                <div class="w-full">
                                    <jet-label for="address_street_number" value="Beneficiário"/>
                                    <jet-input id="benf" type="text" class="mt-1 block w-full"
                                               v-model="receipt.content.correntistaDestino.nome"/>
                                </div>

                                <div class="w-full">
                                    <jet-label for="address_street_number" value="Documento"/>
                                    <jet-input id="docume" type="text" class="mt-1 block w-full"
                                               v-model="receipt.content.correntistaDestino.documentoFederal"/>
                                </div>

                                <div class="w-full">
                                    <jet-label for="address_street_number" value="Numero Banco"/>
                                    <jet-input id="xbanco" type="text" class="mt-1 block w-full"
                                               v-model="receipt.content.bancoDestino.numero"/>
                                </div>

                                <div class="w-full">
                                    <jet-label for="address_street_number" value="Nome Banco"/>
                                    <jet-input id="banco" type="text" class="mt-1 block w-full"
                                               v-model="receipt.content.bancoDestino.descricao"/>
                                </div>

                                <div class="w-full">
                                    <jet-label for="address_street_number" value="Núm Agência"/>
                                    <jet-input id="agencia" type="text" class="mt-1 block w-full"
                                               v-model="receipt.content.agenciaContaDestino.agenciaNumero"/>
                                </div>

                                <div class="w-full">
                                    <jet-label for="address_street_number" value="Número Conta"/>
                                    <jet-input id="conta" type="text" class="mt-1 block w-full"
                                               v-model="receipt.content.agenciaContaDestino.contaNumero"/>
                                </div>

                                <div class="w-full">
                                    <jet-label for="address_street_number" value="Número Conta"/>
                                    <jet-input id="contax" type="text" class="mt-1 block w-full"
                                               v-model="receipt.content.agenciaContaDestino.contaDigito"/>
                                </div>

                                <div class="w-full">
                                    <jet-label for="address_street_number" value="Data agendamento"/>
                                    <jet-input id="codxin" type="text" class="mt-1 block w-full"
                                               v-model="receipt.content.dtTransacao"/>
                                </div>

                                <div class="w-full">
                                    <jet-label for="address_street_number" value="Código Autenticação"/>
                                    <jet-input id="codxixn" type="text" class="mt-1 block w-full"
                                               v-model="receipt.content.codigoAutenticacao"/>
                                </div>
                            </div>

                        </div>

                        <div class="bg-yellow-50 mt-5 p-5 w-1/2 mx-auto" id="transfer-receipt">
                            <table class="w-full">
                                <tbody>
                                <tr>
                                    <td class="px-2 py-2 text-xs text-center font-bold" colspan="2" v-if="logo != null">
                                        <img v-bind:src="`data:${logo.mime};base64, ${logo.base64}`" class="mx-auto"
                                             width="200"/>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-2 py-2 text-xs text-center" colspan="2">
                                        <hr/>
                                    </td>
                                </tr>
                                <tr v-if="extract">
                                    <td class="px-2 py-2 text-xs text-center" colspan="2"
                                        v-if="extract.description == 'ENVIO PIX'">
                                        <span class="text-2xl font-extrabold">ENVIO PIX</span>
                                        <hr class="mt-2"/>
                                    </td>
                                </tr>
                                <td class="px-2 py-2 text-xs text-center font-bold" colspan="2">
                                    DADOS DO PAGADOR
                                </td>
                                <tr v-if="receipt.content.bancoOrigem">
                                    <td class="px-2 py-2 text-sm font-bold">Banco</td>
                                    <td class="px-2 py-2 text-sm text-right">
                                        {{ receipt.content.bancoOrigem.numero }} -
                                        {{ receipt.content.bancoOrigem.descricao }}
                                    </td>
                                </tr>
                                <tr v-if="receipt.content.agenciaContaOrigem">
                                    <td class="px-2 py-2 text-sm font-bold">Conta</td>
                                    <td class="px-2 py-2 text-sm text-right">
                                        {{ receipt.content.agenciaContaOrigem.contaNumero }}-
                                        {{ receipt.content.agenciaContaOrigem.contaDigito }}
                                    </td>
                                </tr>
                                <tr v-if="receipt.content.correntistaOrigem">
                                    <td class="px-2 py-2 text-sm font-bold">Nome</td>
                                    <td class="px-2 py-2 text-sm text-right">
                                        {{ receipt.content.correntistaOrigem.nome }}
                                    </td>
                                </tr>
                                <tr v-if="receipt.content.correntistaOrigem">
                                    <td class="px-2 py-2 text-sm font-bold">Documento</td>
                                    <td class="px-2 py-2 text-sm text-right">
                                        {{ receipt.content.correntistaOrigem.documentoFederal  | federalDocument }}
                                    </td>
                                </tr>
                                <tr v-if="receipt.content.vlrTitulo">
                                    <td class="px-2 py-2 text-sm font-bold">Valor do título</td>
                                    <td class="px-2 py-2 text-sm text-right">
                                        {{ receipt.content.vlrTitulo | currency }}
                                    </td>
                                </tr>
                                <tr v-if="receipt.content.vlrMoraMulta">
                                    <td class="px-2 py-2 text-sm font-bold">Multa</td>
                                    <td class="px-2 py-2 text-sm text-right">
                                        {{ receipt.content.vlrMoraMulta | currency }}
                                    </td>
                                </tr>
                                <tr v-if="receipt.content.vlrOutrosAcres">
                                    <td class="px-2 py-2 text-sm font-bold">Outros acréscimos</td>
                                    <td class="px-2 py-2 text-sm text-right">
                                        {{ receipt.content.vlrOutrosAcres | currency }}
                                    </td>
                                </tr>
                                <tr v-if="receipt.content.vlrDesconto">
                                    <td class="px-2 py-2 text-sm font-bold">Desconto</td>
                                    <td class="px-2 py-2 text-sm text-right">
                                        {{ receipt.content.vlrDesconto | currency }}
                                    </td>
                                </tr>
                                <tr v-if="receipt.content.tituloDtVencimento">
                                    <td class="px-2 py-2 text-sm font-bold">Data do vencimento</td>
                                    <td class="px-2 py-2 text-sm text-right">
                                        {{ receipt.content.tituloDtVencimento | smallDate }}
                                    </td>
                                </tr>
                                <tr v-if="receipt.content.codigoBarras">
                                    <td class="px-2 py-2 text-sm text-center" colspan="2">
                                        <span class="font-bold">Código de barras</span><br/>{{
                                            receipt.content.codigoBarras
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-2 py-2 text-xs text-center" colspan="2">
                                        <hr/>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-2 py-2 text-xs text-center font-bold" colspan="2">
                                        BENEFICIARIO
                                    </td>
                                </tr>
                                <tr v-if="receipt.content.tituloNome">
                                    <td class="px-2 py-2 text-sm text-center" colspan="2">
                                        <span class="font-bold">{{ receipt.content.tituloNome }}</span><br/>
                                        <span>{{ receipt.content.tituloDocumentoFederal | federalDocument }}</span><br/>
                                        <span class="text-3xl font-extrabold">
                                        R$ {{ receipt.content.vlrTransacao | currency }}</span>
                                    </td>
                                </tr>
                                <tr v-if="receipt.content.correntistaDestino">
                                    <td class="px-2 py-2 text-sm text-center" colspan="2">
                                    <span class="font-bold">{{
                                            receipt.content.correntistaDestino.nome
                                        }}</span><br/>
                                        <span>{{
                                                receipt.content.correntistaDestino.documentoFederal | federalDocument
                                            }}</span><br/>
                                        <span class="text-3xl font-extrabold">
                                        R$ {{ receipt.content.vlrTransacao | currency }}</span>
                                    </td>
                                </tr>
                                <tr v-if="receipt.content.bancoDestino">
                                    <td class="px-2 py-2 text-sm font-bold">Banco</td>
                                    <td class="px-2 py-2 text-sm text-right">
                                        {{ receipt.content.bancoDestino.numero }} -
                                        {{ receipt.content.bancoDestino.descricao }}
                                    </td>
                                </tr>
                                <tr v-if="receipt.content.agenciaContaDestino">
                                    <td class="px-2 py-2 text-sm font-bold">Agência</td>
                                    <td class="px-2 py-2 text-sm text-right">
                                        {{
                                            receipt.content.agenciaContaDestino.agenciaNumero
                                        }}-{{ receipt.content.agenciaContaDestino.agenciaDigito }}
                                    </td>
                                </tr>
                                <tr v-if="receipt.content.agenciaContaDestino">
                                    <td class="px-2 py-2 text-sm font-bold">Conta
                                        {{ accountTypes[receipt.content.destinoTipoConta] }}
                                    </td>
                                    <td class="px-2 py-2 text-sm text-right">
                                        {{
                                            receipt.content.agenciaContaDestino.contaNumero
                                        }}-{{ receipt.content.agenciaContaDestino.contaDigito }}
                                    </td>
                                </tr>
                                <tr v-if="receipt.content.descCliente">
                                    <td class="px-2 py-2 text-sm font-bold">Desc. Cliente</td>
                                    <td class="px-2 py-2 text-sm text-right">
                                        {{ receipt.content.descCliente }}
                                    </td>
                                </tr>
                                <tr v-if="receipt.content.tituloNumControle">
                                    <td class="px-2 py-2 text-sm font-bold">Nosso número</td>
                                    <td class="px-2 py-2 text-sm text-right">
                                        {{ receipt.content.tituloNumControle }}
                                    </td>
                                </tr>
                                <tr v-if="extract">
                                    <td class="px-2 py-2 text-sm font-bold">Desc. Operação</td>
                                    <td class="px-2 py-2 text-sm text-right">
                                        {{ receipt.content.DescOperacao || extract.operation_description }}
                                    </td>
                                </tr>
                                <tr v-if="extract">
                                    <td class="px-2 py-2 text-sm font-bold">Cód. Identificador</td>
                                    <td class="px-2 py-2 text-sm text-right">
                                        {{ extract.operation_code }}
                                    </td>
                                </tr>
                                <tr v-if="receipt.content.dtTransacao">
                                    <td class="px-2 py-2 text-sm font-bold">Data do Agendamento</td>
                                    <td class="px-2 py-2 text-sm text-right">
                                        {{ receipt.content.dtTransacao | smallDateTime }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-2 py-2 text-xs text-center" colspan="2">
                                        <hr/>
                                        <span class="text-bold">Autenticação</span><br/>
                                        <span class="text-xs">
                                            {{ receipt.content.codigoAutenticacao }}
                                        </span>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </app-layout>
</template>
<script>
import AppLayout from './../../Layouts/AppLayout'
import Welcome from './../../Jetstream/Welcome'
import JetConfirmationModal from './../../Jetstream/ConfirmationModal';
import JetSecondaryButton from './../../Jetstream/SecondaryButton';
import JetOkButton from './../../Jetstream/OkButton';
import ApplicationMark from './../../Jetstream/ApplicationMark';
import Flash from "../../Helpers/Flash"
import InertiaTable from "../../Helpers/Tables/InertiaTable";
import TransferReceipt from '../Transfer/Receipt';
import BoletoReceipt from '../Boleto/Receipt';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import JetLabel from "../../Jetstream/Label";
import JetInput from "../../Jetstream/Input";

export default {
    components: {
        AppLayout,
        Flash,
        InertiaTable,
        TransferReceipt,
        BoletoReceipt,
        Welcome,
        JetConfirmationModal,
        JetSecondaryButton,
        JetOkButton,
        ApplicationMark,
        JetLabel,
        JetInput
    },
    props: ['receipt', 'extract', 'errors', 'logo'],
    data() {
        return {
            accountTypes: {
                1: 'Corrente',
                2: 'Poupança',
                3: 'Pagamento',
            },
            authCode: ''
        }
    },
    methods: {
        show: function (item) {
            if (item.movement_type === 'D' && item.operation_code !== 'bank-fee' && row.item.operation_code !== 'maintenance' && row.item.operation_code !== 'acquiring-charge-device') {
                this.search('receipts', item, this);
                this.$forceUpdate();
            }
        },
        parseDescription: function (item) {
            switch (item.description.split(' ')[0]) {
                case 'TED':
                    return 'ENVIO TED';
                case 'TRANSFERENCIA':
                    return 'ENTRE CONTAS ' + (item.movement_type == 'D' ? 'DÉBITO' : 'CRÉDITO');
                default:
                    return item.description;
            }
        },
        print() {
            html2canvas(document.querySelector('#transfer-receipt'), {dpi: 144, scale: 1}).then(canvas => {
                let imgData = canvas.toDataURL('image/png');
                let doc = new jsPDF();
                doc.addImage(imgData, 'PNG', 10, 10);
                doc.save('comprovante.pdf');
            });
        },
        makeId(length) {
            let result = '';
            let characters = 'abcdef0123456789';
            let charactersLength = characters.length;
            for (let i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() *
                    charactersLength));
            }
            return result;
        }
    }
}
</script>
